class CreatedFavouriteTransaction {
  id: number;

  constructor(id: number) {
    this.id = id;
  }
}

export { CreatedFavouriteTransaction };
